// ─── DESIGN TOKENS ─────────────────────────────────────────────────────────
const C = {
  primary:       '#1a56db',
  primaryDark:   '#1345b5',
  primaryLight:  '#e8eeff',
  accent:        '#00c896',
  accentDark:    '#009e76',
  warning:       '#f59e0b',
  danger:        '#ef4444',
  bg:            '#f0f4ff',
  card:          '#ffffff',
  surface:       '#f7f9ff',
  border:        '#e2e8f7',
  textPrimary:   '#0f172a',
  textSecondary: '#64748b',
  textMuted:     '#94a3b8',
  navBg:         '#ffffff',
  headerBg:      'linear-gradient(135deg, #1a56db 0%, #1e40af 100%)',
};

export default C;
